import React from 'react';
import Home from './pages/Home';
import Archieve from './pages/Archieve';
import ArchieveCreate from './pages/ArchieveCreate';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import Header from './components/Header';
class Main extends React.PureComponent<any, any>{
    render() {
        return (
            <div className="container">
                <Router>
                    <Switch>
                        <Route exact path="/" render={(props) => {
                            const newProps = { ...props, ...this.props };
                            return <Home {...newProps} />
                        }}>
                        </Route>
                        <Route exact path="/archieve" render={(props) => {
                            const newProps = { ...props, ...this.props };
                            return <ArchieveCreate {...newProps} />
                        }}></Route>
                        <Route path="/archieve/:id" render={(props) => {
                            const newProps = { ...props, ...this.props };
                            return <Archieve {...newProps} />
                        }}>
                        </Route>
                        <Route path="*" component={() => (
                            <React.Fragment>
                                <Header />
                                <h4 className='container-center' style={{ fontSize: '40px' }}>404: Page Not Found</h4>
                            </React.Fragment>
                        )}>
                        </Route>
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default Main;